(() => {
  const config = document.querySelector('[data-fm-measurement]');
  if (!config || window.fmMeasurementBound) return;
  window.fmMeasurementBound = true;
  const privacy = () => window.Shopify?.customerPrivacy;
  const permitted = () => privacy()?.analyticsProcessingAllowed?.() === true && navigator.globalPrivacyControl !== true;
  const safeUrl = (value) => {
    try {
      const url = new URL(value, location.origin);
      if (/\/(pages\/camp(?:-casting)?|account|checkout|checkouts|orders|search|cart)(\/|$)/i.test(url.pathname)) return false;
      if (url.hash && !/^#[a-z0-9_-]{1,80}$/i.test(url.hash)) return false;
      return [...url.searchParams].every(([key, val]) => {
        if (key === 'variant' || key === 'page' || key === 'selling_plan') return /^\d{1,24}$/.test(val);
        if (['fbclid', 'gclid', 'msclkid'].includes(key)) return /^[a-z0-9_-]{1,400}$/i.test(val);
        if (key === 'pack') return ['single', 'pack'].includes(val);
        if (key === 'view') return ['crew', 'uniform'].includes(val);
        if (['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'sort_by'].includes(key)) return /^[a-z0-9_.-]{1,120}$/i.test(val);
        return false;
      });
    } catch (_) { return false; }
  };
  const eligible = config.dataset.enabled === 'true' && config.dataset.live === 'true' && config.dataset.shopping === 'true' &&
    !window.Shopify?.designMode && /^[a-z0-9]{6,20}$/i.test(config.dataset.project || '') &&
    safeUrl(location.href) && (!document.referrer || safeUrl(document.referrer));
  let owned = false;
  let stopped = false;
  const sync = () => {
    if (!eligible || stopped) return;
    if (!permitted()) {
      if (owned) {
        window.clarity('consentv2', { analytics_Storage: 'denied', ad_Storage: 'denied' });
        window.clarity('stop');
        stopped = true;
      }
      return;
    }
    if (!owned) {
      // Leave an existing installation alone: one source owns this integration.
      if (window.clarity || document.querySelector('script[src*="clarity.ms/tag/"]')) return;
      window.clarity = function () { (window.clarity.q = window.clarity.q || []).push(arguments); };
      owned = true;
      window.clarity('consentv2', { analytics_Storage: 'granted', ad_Storage: 'denied' });
      const script = document.createElement('script');
      script.async = true;
      script.src = `https://www.clarity.ms/tag/${config.dataset.project}`;
      document.head.appendChild(script);
    }
  };
  const eventNames = new Set(['fm_pack_selected', 'fm_pack_added', 'fm_look_added', 'fm_image_zoom', 'fm_campaign_play', 'fm_drop_story_open', 'fm_drop_story_shop']);
  document.addEventListener('fm:interaction', event => {
    if (owned && !stopped && permitted() && eventNames.has(event.detail?.name)) window.clarity('event', event.detail.name);
  });
  document.addEventListener('visitorConsentCollected', sync);
  window.addEventListener('pageshow', sync);
  if (privacy()) sync();
  else window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.2' }], error => { if (!error) sync(); });

  const dialog = document.querySelector('[data-fm-privacy-dialog]');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  let opener;
  let overflow;
  const status = dialog.querySelector('[role="status"]');
  const form = dialog.querySelector('form');
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-fm-privacy-open]');
    if (!trigger) return;
    opener = trigger;
    const api = privacy();
    status.textContent = api ? '' : dialog.dataset.unavailable;
    const consent = api?.currentVisitorConsent?.() || {};
    ['analytics', 'marketing', 'preferences'].forEach(purpose => { form.elements[purpose].checked = consent[purpose] === 'yes'; });
    form.querySelectorAll('button[type="submit"]').forEach(button => { button.disabled = !api; });
    overflow = document.body.style.overflow;
    dialog.showModal();
    document.body.style.overflow = 'hidden';
  });
  dialog.querySelector('[data-fm-privacy-close]').addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => { document.body.style.overflow = overflow || ''; opener?.focus(); });
  form.addEventListener('submit', event => {
    event.preventDefault();
    const reject = event.submitter?.value === 'reject';
    const selection = {};
    ['analytics', 'marketing', 'preferences'].forEach(key => { selection[key] = !reject && form.elements[key].checked; });
    const buttons = [...form.querySelectorAll('button[type="submit"]')];
    buttons.forEach(button => { button.disabled = true; });
    const complete = result => {
      buttons.forEach(button => { button.disabled = false; });
      if (result?.error) { status.textContent = dialog.dataset.unavailable; return; }
      sync();
      dialog.close();
    };
    try { privacy().setTrackingConsent(selection, complete); }
    catch (_) { complete({error: true}); }
  });
})();

